'use client'
import { Button } from '@dynamo-caffeina-dev/airc-ui-kit'

import { QueryParamsWrapper } from '@/components/organisms/QueryParamsWrapper'
import { dispatchGTMEvent, GTM_EVENT_CATEGORY } from '@/helpers/gtm'
import { ButtonProps } from '@/types'

const NEWSLETTER_URL = 'https://www.airc.it/newsletter'
const DEFAULT_PARAMS = '?ets_cmmk=5064&ets_sgmt=38070'
const DEFAULT_CONTENT = 'Iscriviti alla newsletter'

const NewsletterButton = (props: ButtonProps) => {
  const handleClick = () => {
    dispatchGTMEvent(GTM_EVENT_CATEGORY.NEWSLETTER, {
      section: props.gtmZone ?? '',
    })
  }
  return (
    <QueryParamsWrapper>
      {(params) => {
        // TODO: make it generic function
        const hasUtmParams = params.has('utm_campaign')
        const linkHasParams = props.href ? new URL(props.href) : null

        const hasExistingUtmParams =
          linkHasParams?.searchParams.has('utm_campaign')

        const queryString =
          hasUtmParams || hasExistingUtmParams
            ? `?${params.toString()}`
            : DEFAULT_PARAMS
        const ctaLink =
          `${!hasUtmParams ? props.href : NEWSLETTER_URL}${queryString}`.replace(
            /\?$/,
            ''
          )

        return (
          <Button
            {...props}
            className='newsletter-button'
            target='_blank'
            href={ctaLink ?? '#'}
            variant={'themed'}
            onClickCapture={handleClick}
          >
            {props.content || DEFAULT_CONTENT}
          </Button>
        )
      }}
    </QueryParamsWrapper>
  )
}

export default NewsletterButton
